import React from "react";
import { Button } from "antd";
import useResponsive from "Context/useResponsive";
interface FilterFooterProps {
  onCancel?: () => void;
}

const FilterFooter: React.FC<FilterFooterProps> = ({ onCancel }) => {
  const { isMobile } = useResponsive();
  const styleCSS: any = {
    paddingTop: "16px",
    borderTop: "1px solid #f0f0f0",
    display: "flex",
    gap: "80px",
    justifyContent: "space-between",
    backgroundColor: "#ffffff",
  };
  const styleCSSMB: any = {
    width: "100%",
    gap: 10,
    display: "flex",
    justifyContent: "space-between",
    flexShrink: 0,
    borderTop: "1px solid #f0f0f0",
    marginBottom: "25px",
    backgroundColor: "#ffffff",
    boxSizing: "border-box",
  };
  return (
    <div style={isMobile ? styleCSSMB : styleCSS}>
      <Button
        onClick={onCancel}
        style={{
          flex: 1,
          height: "45px",
          borderRadius: "10px",
          fontWeight: 700,
          borderColor: "#e2e8f0",
          color: "#1e293b",
        }}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        htmlType="submit"
        style={{
          flex: 1,
          height: "45px",
          borderRadius: "10px",
          fontWeight: 700,
          backgroundColor: "#00a3d9",
          borderColor: "#00a3d9",
          boxShadow: "none",
        }}
      >
        Apply
      </Button>
    </div>
  );
};

export default FilterFooter;
